const selectors = {
  triggerElement: ".sf-value-picker",
  triggerButton: '.value-picker-button',
  closeElement: "[data-action='close-tab']",
  triggerAttribute: "aria-controls",
  search: {
    clearBtnClass: 'search-filter-input__clear'
  },
  sections: {
    collection: '[data-section-type="collection"]'
  },
  filterGroup: '.collection__filter-group',
  filterButton: {
    expanded: '.collection__filter-group-name[aria-expanded="true"]',
  },
  valuePicker: '.value-picker',
  valuePickerBtn: '.value-picker-button',
  expandFiltersButton: 'expand-filters__collection',
  desktopFilters: '.collection__filter-group-list--desktop .collection__filter-group'
};


function unRegisterValuePicker() {
  const $triggerParent = $(selectors.triggerElement);
  const $triggerButton = $triggerParent.find(selectors.triggerButton);
  $triggerButton.each(function (i, el) {
    $(selectors.sections.collection).off("click", $(el))
  });
  const focusElfilterButtonExpanded = document.querySelector(selectors.filterButton.expanded);
  window.openedFilter = focusElfilterButtonExpanded;
  const openedFilterParent = window.openedFilter?.parentNode;
  collapse(openedFilterParent?.querySelector(selectors.valuePicker), window.openedFilter);
}

function collapse(valuePicker, body) {
  if (!valuePicker || !body) {
    return;
  }
  $(valuePicker).attr("aria-hidden", "true");
  $(body).attr("aria-expanded", "false");
}

function registerValuePicker() {
  const $triggerParent = $(selectors.triggerElement);
  const $triggerButton = $triggerParent.find(selectors.triggerButton);

  $triggerButton.each(function (i, el) {
    const toggleElementSelector = $(el).attr("aria-controls");
    const $toggleElement = $(selectors.valuePicker + '#' + toggleElementSelector);

    $(el).on("click", event => {
      //If no toggle selector or element found, return
      if (!!!toggleElementSelector || !!!$toggleElement) {
        return
      }

      if ($toggleElement.attr("aria-hidden") === "true") {
        window.openedFilter = el;
        // Open function
        $(`${selectors.filterGroup} ${selectors.valuePickerBtn}`).attr("aria-expanded", "false");
        $(`${selectors.filterGroup} ${selectors.valuePicker}`).attr("aria-hidden", "true");
        $toggleElement.attr("aria-hidden", "false");
        $(el).attr("aria-expanded", "true");
      } else {
        window.openedFilter = null;
        collapse($toggleElement, $(el));
      }
    });
  });

  document.addEventListener('click', function (ev) {
    if (!window.openedFilter) {
      return;
    }
    const openedFilterParent = window.openedFilter?.parentNode;
    const isClickInsideElement = openedFilterParent.contains(ev.target);
    if (!isClickInsideElement) {
      collapse(openedFilterParent?.querySelector(selectors.valuePicker), window.openedFilter);
      window.openedFilter = null;
    }
  });
}

function toggleFiltersVisibility() {
  const expandFilterButton = document.getElementById(selectors.expandFiltersButton);
  const desktopFilters = document.querySelectorAll(selectors.desktopFilters);
  if (!expandFilterButton || !desktopFilters) return;

  const localeShow = expandFilterButton.dataset.localeShow;
  const localeHide = expandFilterButton.dataset.localeHide;
  const filtersToShow = parseInt(expandFilterButton.dataset.filtersToShow);

  let isFiltersVisible = false;

  expandFilterButton.addEventListener('click', () => {
    desktopFilters.forEach((filter, index) => {
      if (isFiltersVisible && index >= filtersToShow) {
        filter.setAttribute('data-state', 'hidden');
      } else {
        filter.setAttribute('data-state', 'visible');
      }
    });

    isFiltersVisible = !isFiltersVisible;
    expandFilterButton.firstElementChild.innerText = isFiltersVisible ? localeHide : localeShow;
  });
}

toggleFiltersVisibility();

document.addEventListener("DOMContentLoaded", function () {
  registerValuePicker();
});

document.addEventListener('collection:loading:end', function () {
  unRegisterValuePicker()
  registerValuePicker()
  toggleFiltersVisibility();
});
